export { default as ProductFooter } from "./ProductFooter";
